module.exports = __webpack_public_path__ + "img/food-force-reports.759ae0cf.png";